<!--
 * @Description:  员工转正
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-16 09:50:36
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="auto">
            <mrc_ess_switch v-model="list.staff_type_status"
                            v-if="$store.state.uuid"
                            :true-value="1"
                            :false-value="0"
                            :readonly="disabled"
                            :true-text="$t('label_To_enable_the')"
                            :false-text="$t('label_disable')">
            </mrc_ess_switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12"
                 sm="6">
            <!-- 员工类型名称 -->
            <mrc_ess_multiText :label="$t('label_staff_type_name')"
                               noRequired
                               :error-messages="
                  $errors('list', 'staff_type_name', requiredRule)
                  "
                               :isNational="judegNational('staff_type_name')"
                               v-model="list.staff_type_name"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText :label="$t('label_code')"
                               noRequired
                               :error-messages="
                  $errors('list', 'staff_type_code', requiredRule)
                  "
                               :isNational="judegNational('staff_type_code')"
                               v-model="list.staff_type_code"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_describe')"
                               noRequired
                               :error-messages="
                  $errors('list', 'staff_type_description', requiredRule)
                  "
                               :isNational="judegNational('staff_type_description')"
                               v-model="list.staff_type_description"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         @cancel="cancel"
                         :loading="btnIsLoading"
                         v-if="!disabled">
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  staff_type_add,
  staff_type_edit,
  staff_type_detail,
  staff_type_delete,
} from '@/service/api/staffType.js'
import { getBusinessList } from '@/service/api/prompt.js'
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      dropDownList: [],
      list: {
        staff_type_status: 1
      },
      btnIsLoading: false,
      viewList: {},
    }
  },
  computed: {
    complete_probations () {
      //员工转正参照 
      if (this.$store.state.uuid) {
        return {
          prompt_name: 'complete_probation-update',
          org_level_uuid: this.$store.state.currentCompany,
          staff_uuid: this.list.staff_uuid
        }
      } else {
        return {
          prompt_name: 'complete_probations',
          org_level_uuid: this.$store.state.currentCompany,
        }
      }
    },
  },
  created () { },
  watch: {},
  async mounted () {
    this.national('mrbase_sys_staff_type')
    if (this.$store.state.uuid) {
      await this.getDetail()
    }
    else {
    }
  },

  methods: {
    async getDetail () {
      this.skeletonloading = true
      const res = await staff_type_detail({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = res.data
      } else {
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      if (this.$store.state.uuid) {
        staff_type_edit(this.$deletefield(null, this.list)).then(
          async (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t('message_The_operation_was_successful'),
              })
              await this.getDetail()
              this.$emit('changeReadonly')
            }
          }
        )
      }
      else {
        staff_type_add({
          ...this.list,
          org_level_uuid: this.$store.state.currentCompany,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            this.$router.push({ name: 'staffType' })
          }
        })
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getDetail()
        this.$emit('changeReadonly')
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        })
          .then((res) => {
            this.$router.push({
              name: 'staffType',
            })
          })
          .catch((err) => { })
      }

    },
  },
  validations: {
    list: {
      staff_type_name: {
        required,
      },
      staff_type_code: {
        required,
      },
      staff_type_description: {
        required,
      },
    },
  },
}
</script>

<style scoped></style>
